import { render, staticRenderFns } from "./EmailUnsubscribe.vue?vue&type=template&id=5b0839bd&scoped=true"
import script from "./EmailUnsubscribe.vue?vue&type=script&lang=js"
export * from "./EmailUnsubscribe.vue?vue&type=script&lang=js"
import style0 from "./EmailUnsubscribe.vue?vue&type=style&index=0&id=5b0839bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0839bd",
  null
  
)

export default component.exports